export default __webpack_public_path__ + "static/media/result-success.1eb30403.png";